// extracted by mini-css-extract-plugin
module.exports = {"container":"CareerPoint_container__19-Er","wrap":"CareerPoint_wrap__1sI2i","heading":"CareerPoint_heading__JVIvF","image":"CareerPoint_image__EQ3wp"};